import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
}

const TrendingFlat: React.FC<Props> = ({
  size = 18,
  color = '#216CC2',
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role="img"
    {...rest}
  >
    <path d="M22 12l-4-4v3H3v2h15v3z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

export default TrendingFlat;
